import { call, put, select, takeEvery } from 'redux-saga/effects';
import * as onlineStoreAction from 'actions/onlineStore';
import {
  ONLINE_STORE_START_SELECT_OUTLET_FLOW,
  ONLINE_STORE_SELECT_OUTLET,
} from 'actions/onlineStore/constants';
import { ONLINE_STORE_CHANNEL } from 'utils/onlineStoreUtils';
import * as onlineStoreApi from 'api/onlineStore';

function isShopCreated(shops, outletId) {
  return shops.some(shop => shop.outlet_id === outletId);
}

function onlyHasOneOutlet(outlets, shops) {
  return outlets.length === 1 && !isShopCreated(shops, outlets[0].id);
}

function* getOutletInfo(outletId) {
  try {
    const { data } = yield call(onlineStoreApi.getOutlet, outletId);
    return data;
  } catch (e) {
    return null;
  }
}

function* startSelectOutletFlow({ payload }) {
  const { channel } = payload;
  const outlets = yield select(state => state.moka.user.outlets);
  const shops = yield select(state => state.onlineStore.shop.shops);

  if (
    onlyHasOneOutlet(outlets, shops) &&
    channel === ONLINE_STORE_CHANNEL.FACEBOOK
  ) {
    const { id, name } = outlets[0];
    yield put(
      onlineStoreAction.selectOutlet({
        channel,
        outletId: id,
        outletName: name,
        source: payload.source,
      })
    );
    yield put(onlineStoreAction.closeOutletModal());

    return;
  }

  yield put(onlineStoreAction.showOutletModal());
}

function* outletSelectedFlow({ payload }) {
  const { outletId, outletName, source, channel } = payload;
  const outletInfo = yield getOutletInfo(outletId);

  if (!outletInfo || !outletInfo.is_go_store_activated) {
    yield put(onlineStoreAction.closeOutletModal());
    yield put(onlineStoreAction.showGoStoreUnActivatedModal());
    yield put(onlineStoreAction.selectOutletInfo(outletInfo));

    return;
  }

  switch (channel) {
    case ONLINE_STORE_CHANNEL.FACEBOOK:
      yield put(
        onlineStoreAction.startFacebokSignInFlow({
          outletId,
          outletName,
          source,
          outletInfo,
        })
      );
      break;
    case ONLINE_STORE_CHANNEL.GOOGLE:
      if (!outletInfo || !outletInfo.is_nation_wide_shipping) {
        yield put(onlineStoreAction.closeOutletModal());
        yield put(onlineStoreAction.showGoStoreNotNationWideShippingModal());
        yield put(onlineStoreAction.selectOutletInfo(outletInfo));

        return;
      }

      yield put(
        onlineStoreAction.connectGoogleShop({ outletId, outletName, source })
      );
      break;
  }
}

export default function* outletModalSaga() {
  yield takeEvery(ONLINE_STORE_START_SELECT_OUTLET_FLOW, startSelectOutletFlow);
  yield takeEvery(ONLINE_STORE_SELECT_OUTLET, outletSelectedFlow);
}
